// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header___esbk","footer":"ModalInfo_footer__wp5cQ"};